import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount, currency = 'INR') {
  const currencySymbols = {
    INR: '₹',
    USD: '$',
    AED: 'د.إ',
    GBP: '£',
    AUD: 'A$',
  };
  
  const symbol = currencySymbols[currency] || currency;
  const value = Number(amount);
  if (!Number.isFinite(value)) return `${symbol}0`;
  const sign = value < 0 ? '-' : '';
  amount = Math.abs(value);
  
  if (amount >= 10000000) {
    return `${sign}${symbol}${(amount / 10000000).toFixed(2)}Cr`;
  } else if (amount >= 100000) {
    return `${sign}${symbol}${(amount / 100000).toFixed(2)}L`;
  } else if (amount >= 1000) {
    return `${sign}${symbol}${(amount / 1000).toFixed(1)}K`;
  }
  
  return `${sign}${symbol}${amount.toLocaleString()}`;
}

export function formatNumber(num) {
  if (num >= 1000000) {
    return `${(num / 1000000).toFixed(1)}M`;
  } else if (num >= 1000) {
    return `${(num / 1000).toFixed(1)}K`;
  }
  return num.toLocaleString();
}

export function formatDate(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function getStatusColor(status) {
  const colors = {
    active: 'success',
    approved: 'success',
    completed: 'success',
    resolved: 'success',
    pending: 'warning',
    under_review: 'warning',
    won: 'success',
    lost: 'danger',
    processing: 'warning',
    in_progress: 'warning',
    registering: 'warning',
    blocked: 'danger',
    rejected: 'danger',
    suspended: 'danger',
    frozen: 'info',
    closed: 'neutral',
    resubmission_required: 'warning',
  };
  return colors[status?.toLowerCase()] || 'neutral';
}

export function getInitials(name) {
  if (!name) return '?';
  return name
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

export function truncateText(text, maxLength = 50) {
  if (!text || text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
}

export function generateId() {
  return Math.random().toString(36).substring(2, 15);
}

export function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

export function getGameVariantLabel(variant) {
  const labels = {
    points_rummy: 'Points Rummy',
    pool_101: 'Pool 101',
    pool_201: 'Pool 201',
    deals_rummy: 'Deals Rummy',
  };
  return labels[variant] || variant;
}

export function getSeverityColor(severity) {
  const colors = {
    low: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
    medium: 'bg-amber-500/20 text-amber-400 border-amber-500/30',
    high: 'bg-orange-500/20 text-orange-400 border-orange-500/30',
    critical: 'bg-red-500/20 text-red-400 border-red-500/30',
  };
  return colors[severity] || colors.medium;
}

export function getPriorityColor(priority) {
  const colors = {
    low: 'bg-slate-500/20 text-slate-400 border-slate-500/30',
    medium: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
    high: 'bg-amber-500/20 text-amber-400 border-amber-500/30',
    urgent: 'bg-red-500/20 text-red-400 border-red-500/30',
  };
  return colors[priority] || colors.medium;
}

export function downloadCSV(data, filename) {
  const headers = Object.keys(data[0]);
  const csvContent = [
    headers.join(','),
    ...data.map(row => headers.map(h => JSON.stringify(row[h] || '')).join(','))
  ].join('\n');
  
  const blob = new Blob([csvContent], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}.csv`;
  a.click();
  window.URL.revokeObjectURL(url);
}
